<script lang="ts">
import { SwitchInput } from '@goodlifeplus/component-library'
import { defineComponent } from 'vue'

/**
 * A toggle element.
 */
export default defineComponent({
  components: {
    SwitchInput,
  },
  props: {
    /**
     * Name of the toggle element.
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Model prop to v-bind to.
     */
    modelValue: {
      type: Boolean,
      required: true,
    },
    /**
     * The value of the checkbox.
     * If none is set, the value will be "true" or "false" depending on the checked state.
     */
    value: {
      type: String,
    },
    /**
     * Reverse the placement of the toggle to label slot.
     * Default: toggle on left, text on right.
     */
    reverseOrder: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    checked: {
      get() {
        return this.modelValue
      },
      set(checked: boolean) {
        this.$emit('update:modelValue', checked)
      },
    },
  },
})
</script>

<template>
  <label
    class="inline-flex items-center hover:cursor-pointer"
    :class="{ 'flex-row-reverse': reverseOrder }"
  >
    <SwitchInput
      v-model="checked"
      :disabled="disabled"
      :name
      :value="value ?? checked"
    />

    <span :class="[reverseOrder ? 'mr-2' : 'ml-2']">
      <!-- @slot Used to place content next to the toggle element. -->
      <slot />
    </span>
  </label>
</template>
